import * as React from 'react';
import { InputBaseModel } from '../models';

export default (inputId: string, inputs?: InputBaseModel[]) => {
    return React.useMemo(() => inputs?.find(i => i.id === inputId), [inputs, inputId]);
};
